import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import { useRef } from 'react';
import { OutpostDestinationTypeField, OutpostDestinationTypeMetadata } from '../../../../../../../typings/outpost';
import Button, { PlaceholderButton } from '../../../common/base/Button';
import Text from '../../../common/base/Text';
import CopyableField from '../../../common/CopyableField';
import TextInput from '../../../common/Form/Fields/TextInput';
import { Div } from '../../../common/helpers/StyledUtils';
import Icon from '../../../common/base/Icon';
export type KeyValueEntry = [string, string];
export const validateField = (field: OutpostDestinationTypeField) => (value: string) => {
  if (field.required && (!value || !value.trim())) {
    return `${field.label} is required`;
  }
  if (field.pattern && value) {
    const regex = new RegExp(field.pattern);
    if (!regex.test(value)) {
      return `${field.label} does not match the expected format`;
    }
  }
  return undefined;
};
export const KeyValueMapField = ({
  field_key,
  label
}: {
  field_key: string;
  label: string;
}) => {
  const name = `config.${field_key}`;
  const [{
    value
  },, {
    setValue
  }] = useField<KeyValueEntry[]>(name);
  const render_key_ref = useRef(new Date().getTime());
  const entries: KeyValueEntry[] = Array.isArray(value) && value.length > 0 ? value : [];
  const removeEntry = (index: number) => {
    const new_entries = [...entries];
    new_entries.splice(index, 1);
    setValue(new_entries.length === 0 ? [] : new_entries);
    render_key_ref.current = new Date().getTime();
  };
  const addEntry = () => {
    setValue([...entries, ['', '']]);
  };
  return <>
      <Text semi size="xs" muted m={{
      t: 2,
      b: 2
    }}>
        {label}
      </Text>
      {entries.map((_, i) => <Div key={`${render_key_ref.current}-${i}`} flex={{
      align: 'center',
      gap: 3
    }} m={{
      b: 2
    }}>
          <TextInput w={100} m={0} name={`${name}[${i}][0]`} placeholder="Key" mono />
          <TextInput w={100} m={0} name={`${name}[${i}][1]`} placeholder="Value" mono />
          <Button outline icon="delete" onClick={() => removeEntry(i)} />
        </Div>)}
      <PlaceholderButton m={{
      t: entries.length === 0 ? 0 : 1
    }} p={1.5} onClick={addEntry}>
        Add entry
      </PlaceholderButton>
    </>;
};
export const SetupLinkField = t0 => {
  const $ = _c(4);
  const {
    destination_type
  } = t0;
  if (!destination_type.setup_link) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      b: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text size="s" m={{
      b: 2
    }}><Icon icon="info" /> Share this URL with your user to generate a token.</Text>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== destination_type.setup_link.href) {
    t3 = <Div m={t1}>{t2}<CopyableField value={destination_type.setup_link.href} mono={true} /></Div>;
    $[2] = destination_type.setup_link.href;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};